<!-- Compiled from legacy/Plus/Plus/timeline/index.shtml (May 2014 entry) -->

<template>
  <h3><span style="font-weight: 200">'VizbiPlus on the Big Screen'</span></h3>
  <h4>May 2014 &mdash; Federation Square, Melbourne</h4>
  <p>
    During May 2014, three VizbiPlus animations were shown on the Big Screen at Federation
    Square in Melbourne, bringing scientifically accurate visualizations of biomedical research
    to one of Australia's busiest public spaces.
  </p>
  <img
    class="banner"
    src="/Plus/Timeline/Federation-Square-Big-Screen-2.jpg"
    alt="Kate Patterson's 'Cancer Is Not One Disease' playing at Federation Square" />
  <p>
    Kate Patterson's <em>'Cancer Is Not One Disease'</em> playing on the Big Screen in
    Melbourne's Federation Square.
  </p>
  <img
    class="banner"
    src="/Plus/Timeline/Federation-Square-Big-Screen-1.jpg"
    alt="'The Hungry Microbiome' playing at Federation Square" />
  <p>
    Christopher Hammang's <em>'The Hungry Microbiome'</em> playing on the Big Screen. All three
    animations are available to watch on the
    <router-link to="/Plus">VizbiPlus</router-link> page.
  </p>
</template>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
  clear: both;
}
img.banner {
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}
</style>
